'use strict';

angular.module('internal.investigations')
    .controller('InternalInvestigationDocument', ['$scope', '$stateParams', '$state', 'Documents', 'Upload', 'DocumentTypes', '$q', 'FileTypes',
        function ($scope, $stateParams, $state, Documents, Upload, DocumentTypes, $q, FileTypes) {
        $scope.resetInvestigation();
        $scope.investigation_document = $stateParams.investigation_document;
        $scope.investigationDocumentID = $stateParams.investigationDocumentID;
        $scope.saving = false;
        $scope.deleting = false;
        $scope.loading = true;
        $scope.types = [];
        $scope.extensions = '*';
        
        if ($stateParams.investigationDocumentID != null) {
            var a = Documents.getByID($stateParams.investigationDocumentID).then(function (document) {
                $scope.investigation_document = document;                
            })

            var b = DocumentTypes.get({ check_permission: true }).then(function (types) {
                $scope.types = types;
            })

            $q.all([a, b]).then(function () {
                $scope.loading = false;
            }).catch(function (response) {
                // handle error
            });
        }
        else {
            $scope.investigation_document = {};
            FileTypes.getByEnterprise().then(function (data) {
                if (data != null && data.length > 0) {
                    $scope.extensions = data.toString();
                } else {
                    $scope.extensions = '*';
                }
                $scope.loading = false;
            });
        }

        $scope.save = function () {
            $scope.saving = true;

            if ($scope.investigationDocumentID == null) {
                $scope.investigation_document.fromComplaint = true;
                Documents.upload($scope.investigation_document, $scope.investigationID).then(function (document) {
                    if (document != null) {
                        updateArray($scope.investigation.documents, document);
                        updateArray($scope.masterInvestigation.documents, document);
                        $state.go('internal.licensing.investigation.documents', { id: $scope.investigationID }, { reload: true });
                    }
                    else {
                        alert("Upload failed. File is too large");
                    }
                    $scope.saving = false;
                });
            }
            else {
                Documents.save($scope.investigation_document, true, $scope.investigationID).then(function (document) {
                    updateArray($scope.investigation.documents, document);
                    updateArray($scope.masterInvestigation.documents, document);
                    $state.go('internal.licensing.investigation.documents', { id: $scope.investigationID });
                    $scope.saving = false;
                });
            }
        }

        $scope.delete = function () {
            $scope.deleting = true;

            Documents.delete($stateParams.investigationDocumentID).then(function () {
                updateArray($scope.investigation.documents, $scope.investigation_document, true);
                updateArray($scope.masterInvestigation.documents, $scope.investigation_document, true);
                $scope.deleting = false;
                $state.go('internal.licensing.investigation.documents', { id: $scope.investigationID });
            });
        }

        $scope.hasDocumentTypePermission = function (document) {
            var permission = false;

            if (document != null) {
                if (document.document_type_id == null) {
                    permission = true;
                }
                else {
                    $scope.types.forEach(function (type) {
                        if (type.id == document.document_type_id) {
                            permission = true;
                        }
                    })
                }
            }

            return permission;
        }
    }])
;